import classNames from "classnames";
import noop from "lodash/noop";
import { FunctionComponent, ReactNode } from "react";

import "./style.scss";

export interface Props {
  children: ReactNode;
  disabled?: boolean;
  href?: string;
  icon?: JSX.Element;
  iconPosition?: "left" | "right";
  onClick?: (event: MouseEvent) => void;
  size: "s" | "m";
  targetBlank?: boolean;
}

const Link: FunctionComponent<Props> = ({
  children,
  disabled = false,
  href,
  icon,
  iconPosition,
  onClick = noop,
  size,
  targetBlank = false,
}) => {
  const className = classNames(`Link Link--size-${size}`, {
    "Link--disabled": disabled,
    "Link--icon-left": iconPosition === "left",
    "Link--icon-right": iconPosition === "right",
  });

  return (
    <>
      {targetBlank ? (
        <a
          className={className}
          href={disabled ? undefined : href}
          onClick={onClick}
          rel="noopener noreferrer"
          target="_blank"
        >
          {!!icon && iconPosition === "left" && icon}
          {children}
          {!!icon && iconPosition === "right" && icon}
        </a>
      ) : (
        <a className={className} href={disabled ? undefined : href} onClick={onClick}>
          {!!icon && iconPosition === "left" && icon}
          {children}
          {!!icon && iconPosition === "right" && icon}
        </a>
      )}
    </>
  );
};

export default Link;
